exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-custom[data-v-5fbac8ca]{max-width:700px;background-color:#fff}ul.file-list[data-v-5fbac8ca]{list-style-type:none;padding:0;margin:1em 0}", ""]);

// exports
